// @flow

import { v1 as uuidv1 } from 'uuid';

/**
 * Generate a random guid each time this func is called
 *
 * @return {String} The random guid
 */
const guid = () => uuidv1();

export default guid;
